<template>
  <el-container>
    <el-header>
      <el-input
        placeholder="输入姓名查询"
        size="mini"
        class="inp-w"
        v-model="tongxing.dUserName"
      ></el-input>
      <el-select
        placeholder="请选择通道"
        size="mini"
        v-model="tongxing.drivewayId"
      >
        <el-option
          v-for="item in drivewayList"
          :key="item.drivewayId"
          :label="item.drivewayName"
          :value="item.drivewayId"
        >
        </el-option>
      </el-select>
      <!-- 时间 -->
      <el-date-picker
        size="mini"
        v-model="changeTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
      >
      </el-date-picker>
      <el-button size="mini" @click="clearParams" type="primary"
        >清空查询数据</el-button
      >
      <el-button size="mini" type="primary" @click="getPassInfoList()"
        >查询</el-button
      >
    </el-header>
    <el-main>
      <el-table
        size="mini"
        :data="passList"
        stripe
        border
        :header-cell-style="{ background: '#409eff', color: '#fff' }"
      >
        <el-table-column
          prop="userName"
          align="center"
          label="姓名"
        ></el-table-column>
        <el-table-column
          prop="userIcNum"
          align="center"
          label="IC卡号"
        ></el-table-column>
        <el-table-column
          prop="inOrOut"
          align="center"
          label="出入方向"
        ></el-table-column>
        <el-table-column align="center" label="时间">
          <template slot-scope="scope">
            {{ scope.row.recorderDate | setTimeData(that) }}
          </template>
        </el-table-column>
        <el-table-column prop="drivewayName" align="center" label="通道">
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <el-pagination
        @size-change="txhandleSizeChange"
        @current-change="txhandleCurrentChange"
        :current-page="txfy.page"
        :page-sizes="[20, 30, 40, 50]"
        :page-size="txfy.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="txfy.total"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
moment.locale("zh-cn"); //需要汉化
export default {
  data() {
    return {
      that: this,
      tongxing: {
        dUserName: "",
        drivewayId: "",
        recorderStartDate: "",
        recorderEndDate: ""
      },
      txfy: {
        total: 0,
        pageSize: 20,
        page: 1
      },
      drivewayList: [], //通道列表
      changeTime: [], //时间选择
      passList: [] //数据
    };
  },
  filters: {
    setTimeData(time, that) {
      return moment(time).format("LLL");
    }
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.getPassInfoList();
    this.queryDrivewayList();
  },
  mounted() {},
  methods: {
    txhandleSizeChange(val) {
      this.txfy.pageSize = val;
      this.getPassInfoList();
    },
    txhandleCurrentChange(val) {
      this.txfy.page = val;
      this.getPassInfoList();
    },
    /*
     **  @description 查询通道列表
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryDrivewayList() {
      this.$axios
        .get(`/dapi/nhw/driveway/find?drivewayArea=${this.userinfo.uid}`)
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            if (data.data.length > 0) {
              this.drivewayList = data.data;
              //   this.changeDriveway();
            }
          } else {
            this.$message.error("暂无通道数据");
          }
        });
    },
    /*
     **  @description 清空查询数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    clearParams() {
      Object.assign(this.$data.tongxing, this.$options.data().tongxing);
    },

    getPassInfoList() {
      if (this.changeTime && this.changeTime.length > 0) {
        this.tongxing.recorderStartDate = this.changeTime[0];
        this.tongxing.recorderEndDate = this.changeTime[1].replace(
          "00:00:00",
          "23:59:59"
        );
      } else {
        this.tongxing.recorderStartDate = "";
        this.tongxing.recorderEndDate = "";
      }
      let params = {
        netArea: this.userinfo.uid,
        ...this.tongxing,
        ...this.txfy
      };

      this.$axios
        .get("/dapi/nhw/find/recorder", {
          params: {
            ...params
          }
        })
        .then(data => {
          let res = data.data;
          if (res.status == 200) {
            this.txfy.total = res.data.count;
            this.passList = res.data.list;
          } else {
            this.passList = [];
            this.txfy.total = 0;
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.el-container {
  .el-header {
    text-align: left;
    padding: 16px 20px;
    .inp-w {
      width: 200px;
    }
    & > * {
      margin-right: 20px;
    }
    .el-date-editor {
      padding: 2px 10px;
    }
  }
}
</style>
